/*
 * @Author: LiuLiXue QQ:136890965
 * @Date: 2017-12-28 16:25:23
 * @Last Modified by: LiuLiXue
 * @Last Modified time: 2017-12-28 17:50:08
 */
//商户管理接口
import fetch from '@/utils/fetch';
import {shop_url} from '@/global';

// 分页查询商户列表
const getMerList = (page = 1, rows = 10, name = '', phone = '') => {
  const url = `${shop_url}/shop/cms/mchs`;
  const method = 'post';
  const data = {
    page,
    rows,
    name,
    phone
  };
  // let data = {};
  // if (isFind) {
  //   data = {
  //     page,
  //     rows,
  //     name,
  //     phone
  //   }
  // } else {
  //   data = {
  //     page,
  //     rows
  //   }
  // }
  return fetch({
    url,
    method,
    data
  })
}
//获取结算的模板
const getRate = (type) => {
  const url =`${shop_url}/shop/cms/mch/fee/type/`+type;
  const method = 'get';
  return fetch({
    url,
    method
  })
}
//删除费率模板
const delRate = (id) => {
  const url =`${shop_url}/shop/cms/mch/fee`;
  const method = 'delete';
  let data={id}
  return fetch({
    url,
    method,
    data
  })
}
//分页查询结算的模板
const selectAllRate = (page,rows) => {
  const url =`${shop_url}/shop/cms/mch/fee/`+page+"/"+rows;
  const method = 'get';
  return fetch({
    url,
    method
  })
}
//新增商户
const AddMerchant = (feeId,thirdFeeId,name,address,description,bankName,bankAccountName,bankAccountNo,phone,managerPhones,logo) => {
  const url =`${shop_url}/shop/cms/mch`;
  const method = 'put';
  const data={feeId,thirdFeeId,name,address,description,bankName,bankAccountName,bankAccountNo,phone,managerPhones,logo}
  return fetch({
    url,
    method,
    data
  })
}
//添加结算模板
const AddRate = (day,feeRate,type) => {
  const url =`${shop_url}/shop/cms/mch/fee`;
  const method = 'put';
  let data={day,feeRate,type};
  return fetch({
    url,
    method,
    data
  })
}
//编辑结算模板
const EditRate = (id,day,feeRate,type) => {
  const url =`${shop_url}/shop/cms/mch/fee`;
  const method = 'patch';
  let data={id,day,feeRate,type};
  return fetch({
    url,
    method,
    data
  })
}
//检查手机号是否冻结
const freezes =(phone) =>{
  const url =`${shop_url}/shop/cms/mch/check`;
  const method = "post";
  let data={phone};
  return fetch({
    url,
    method,
    data
  })
}
// 删除商户
const deleteMch = (id,type=1) => {
  const url = `${shop_url}/shop/cms/mch/active`;
  const method = 'put';
  const data = {
    id,
    type
  }
  return fetch({
    url,
    method,
    data
  })
}
//编辑商户  数据回显
const Mercompile = (id) => {
  const url = `${shop_url}/shop/cms/mch/`+id;
  return fetch({
    url
  })
}
//修改商户
const updataMer = (id,name,address,description,bankName,bankAccountName,bankAccountNo,phone,managerPhones,feeId,thirdFeeId,logo) => {
  const url =`${shop_url}/shop/cms/mch/info`;
  const method = 'put';
  let data = {};
  if(feeId){
  data={id,name,address,description,bankName,bankAccountName,bankAccountNo,phone,managerPhones,feeId,thirdFeeId,logo}
  }else{
    data={id,name,address,description,bankName,bankAccountName,bankAccountNo,phone,managerPhones,logo}
  }
  return fetch({
    url,
    method,
    data
  })
}
export {
  getMerList,
  getRate,
  AddMerchant,
  AddRate,
  deleteMch,
  Mercompile,
  updataMer,
  selectAllRate,
  delRate,
  EditRate,
  freezes
}
/* 根据关键字 获取二维码 */
export const getMerchantBycode = (id)=>{
  return fetch({
    url:`${shop_url}/shop/cms/QrcodeDown/`+id,
    method:'get'
  })
}



// WEBPACK FOOTER //
// ./src/api/merchant/merchManage.js